import { Action } from 'redux';

import { IOrderClause } from '../../ts/ServerApi/types/IOrderClause';
import { SetOrder } from './AppActionTypes';
import { isActionFactory } from './isActionFactory';

export interface SetOrderAction extends Action {
  order: ReadonlyArray<IOrderClause>;
}

export function setOrderAction(order: ReadonlyArray<IOrderClause>): SetOrderAction {
  return {
    type: SetOrder,
    order: order
  };
}

export const isSetOrderAction = isActionFactory<SetOrderAction>(SetOrder);
